
<script>
	import listBase from '@_system/components/base/list.vue'
	import takedepartmentForm from './takedepartment/index.vue'
	import phonePage from './phonePage/index.vue'
	import statisticsIndex from './statistics/index.vue'
	import orderdetailIndex from './orderdetail/index.vue'
	export default {
		extends: listBase,
		name: 'takegoodsIndex',
		props: {

		},
		render(h) {
			this.$slots.phonePage = [
				<phonePage ref="phonePage" />,
			
			]
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showoutofstock} onChange={this.outofstockChange} active-text="显示缺货" inactive-text=""></el-switch>,
				<el-switch style="padding-left:20px" v-model={this.showotherdepartment} onChange={this.showotherdepartmentChange} active-text="显示其他部门" inactive-text=""></el-switch>,
				<el-switch style="padding-left:20px" v-model={this.showtake} onChange={this.showtakeChange} active-text="显示已提货" inactive-text=""></el-switch>
			
			]
			this.$slots.plug = [
				<takedepartmentForm billIDs={this.billIDs} onSuccess={this.success} ref="takedepartmentForm" />,
				<statistics-index ref="statistics" onShowdetail={this.showdetail} />,
				<orderdetail-index ref="orderdetail" data={this.orderDetailData} onModalhide={this.orderdetailHide} />
			
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				showoutofstock:false,
				phonePage:'custom',
				showtake:false,
				showotherdepartment:false,
				moduleName: 'takegoods',
				windowName: '提货',
				windowType: 'modal',
				billIDs:[],
				orderDetailData:null,
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			outofstockChange(e){
				this.foreingKey.outofstock = e?1:0
				this.customreload()
			},
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field=='skuName'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.isoutofstock==1){
									str.push(<el-tag size="mini" type="info" effect="dark" style="margin-right: 2px;">缺</el-tag>)
								}
								str.push(<span>{row.skuName}</span>)
								return str
							}
						}
					}
				})
				
			},
			statistics(){
				this.$refs.statistics.modalShow()
			},
			showdetail(e){
				this.orderDetailData = e.data
				this.$refs.orderdetail.modal_show()
			},
			orderdetailHide(){
				this.$refs.scheduling.init()
			},
			showtakeChange(e){
				this.foreingKey.showtake = e?1:0
				this.customreload()
			},
			showotherdepartmentChange(e){
				this.foreingKey.showotherdepartment = e?1:0
				this.customreload()
			},
			takebatchgoods(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择商品')
					return
				}
				data = this.$Lodash.groupBy(data, 'billID')
				let parr = []
				for(let i in data){
					parr.push(this.takegoodsApi(data[i]))
				}
				Promise.all(parr).then(()=>{
					this.$message.success('操作成功')
					this.customreload()
				})
			},
			updatetakedepartment(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择商品')
					return
				}
				data = this.$Lodash.groupBy(data, 'billID')
				this.billIDs = this.$Lodash.keys(data)
				this.$refs.takedepartmentForm.modalShow()
			},
			success(){
				this.customreload()
			},
			takegoods(row){
				this.takegoodsApi([row])
			},
			cancel(row){
				this.takegoodsApi([row],'cancel')
			},
			takegoodsApi(data,type='takegoods'){
				return new Promise(()=>{
					this.$api.wlnpurchase.takegoods({
						data: data,
						type:type
					}).then(() => {
						this.$message.success('操作成功')
						this.customreload()
					})
				})
			},
			cellStyle({
				row,
				column
			}) {
				let map = {
					takeStatus:{
						0:'#F56C6C',
						1:'#67C23A',
						2:'#409EFF',
					}
				}
				if(map[column.field]){
					return {
						color: map[column.field][row[column.field]]
					}
				}

			},
		},
		components: {
			statisticsIndex,
			orderdetailIndex
		}
	}
</script>
